import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import { noop } from 'lib/utils';

const FilterOffersByPriceRange = dynamic(
  () => import('./FilterOffersByPriceRange')
);
const FilterOffersByStore = dynamic(() => import('./FilterOffersByStore'));
const FilterOffersByVenue = dynamic(() => import('./FilterOffersByVenue'));

const CategoryFilters = ({
  gaEventCategory,
  isWithinDrawer = false,
  offersFilters,
  stores,
  onClose = noop,
  onOffersFiltersReset,
  onOffersPriceRangeFilterChange,
  onOffersStoresFilterChange,
  onOffersVenueFilterChange,
}) => (
  <>
    {!isWithinDrawer && (
      <FilterOffersByVenue
        className="mb-4 w-full p-4"
        gaEventCategory={gaEventCategory}
        venue={offersFilters.venue}
        onOffersVenueFilterChange={(venue) => {
          onOffersVenueFilterChange(venue);
          onClose();
        }}
      />
    )}
    {stores.length > 0 && (
      <FilterOffersByStore
        gaEventCategory={gaEventCategory}
        isWithinDrawer={isWithinDrawer}
        stores={offersFilters.stores}
        storesList={stores}
        onOffersFiltersResetClick={() => {
          onOffersFiltersReset();
          onClose();
        }}
        onOffersStoresFilterChange={(store) => {
          onOffersStoresFilterChange(store);
          onClose();
        }}
      />
    )}
    {offersFilters && (
      <FilterOffersByPriceRange
        className={twJoin('w-full', isWithinDrawer ? 'px-0' : 'mb-0 px-4')}
        gaEventCategory={gaEventCategory}
        priceRange={offersFilters.priceRange}
        onOffersPriceRangeFilterChange={(priceRange) => {
          onOffersPriceRangeFilterChange(priceRange);
          onClose();
        }}
      />
    )}
  </>
);

CategoryFilters.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isWithinDrawer: PropTypes.bool,
  offersFilters: PropTypes.shape({
    priceRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }).isRequired,
    stores: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.number.isRequired,
        storeName: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.number.isRequired,
      storeName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func,
  onOffersFiltersReset: PropTypes.func.isRequired,
  onOffersPriceRangeFilterChange: PropTypes.func.isRequired,
  onOffersStoresFilterChange: PropTypes.func.isRequired,
  onOffersVenueFilterChange: PropTypes.func.isRequired,
};

export default CategoryFilters;
